import Api from '../../../common/services/api';

export const ADMIN_UPDATE_TEAM = 'admin/UPDATE_TEAM';
export const ADMIN_START_EDIT_TEAM = 'admin/START_EDIT_TEAM';
export const ADMIN_START_EDIT_TEAM_STOP = 'admin/STOP_EDIT_TEAM';

export const startEdit = (teamId) => ({ type: ADMIN_START_EDIT_TEAM, teamId });
export const stopEdit = () => ({ type: ADMIN_START_EDIT_TEAM_STOP });

export default (values) => async (dispatch, getState) => {
  const { network: { selected } } = getState();

  const path = `/v2/networks/${selected}/teams/${values.id}`;

  const { data: team } = await Api.put(path, {
    name: values.name,
    functionIds: values.functionIds
  });

  return dispatch({
    type: ADMIN_UPDATE_TEAM,
    team,
  });
};
